import React from 'react';
import ModuleTable from 'Components/Core/ModuleTable';
import Dialog from 'Components/Core/Dialog';
import 'CSS/Admin/PushSubscriptions.css';

export default function PushSubscriptions(props) {

	const x = props.x;
	const dialogId = props.id + '-detail';

	const [detail, setDetail] = React.useState(null);

	return (
		<React.Fragment>
			<ModuleTable
				id={props.id}
				tableId="endpoint"
				dialogFormId={props.id + '-form'}
				x={x}
				classes={`module-push-subscriptions`}
				tableClasses={`push-subscriptions-list`}
				filterableColumns={['membername', 'endpoint', 'useragent']}
				title={props.title}
				hideAddButton={true}
				addDeleteRow={x.was.memberLevel === 1}
				module="Admin"
				listTask="PushSubscriptionList"
				deleteTask="DeletePushSubscriptionAdmin"
				onAddHeader={(addHeader) => {
					addHeader('Mitglied');
					addHeader('Endpoint');
					addHeader('User-Agent');
					addHeader('Erstellt');
				}}
				onAddColumn={(key, value) => {
					switch (key) {
						case 'membername':
						case 'createdate':
							return value;
						case 'endpoint':
						case 'useragent':
							return <span title={value} className="push-subscriptions-truncate">{value}</span>;
						default:
							return false;
					}
				}}
				onEditRow={(e, rowFields, rowId) => {
					setDetail(rowFields);
					x.wad[dialogId].show();
				}}
			/>
			<Dialog id={dialogId} x={x} display="d-none" classes="dialog-push-subscription-detail" title="Push-Subscription" modal={true}>
				{detail &&
					<div className="push-subscription-detail-content">
						<div className="detail-label">Mitglied</div>
						<div className="detail-value">{detail.membername} ({detail.memberid})</div>
						<div className="detail-label">Endpoint</div>
						<div className="detail-value detail-value-break">{detail.endpoint}</div>
						<div className="detail-label">User-Agent</div>
						<div className="detail-value detail-value-break">{detail.useragent}</div>
						<div className="detail-label">Erstellt</div>
						<div className="detail-value">{detail.createdate}</div>
					</div>
				}
			</Dialog>
		</React.Fragment>
	)

};
